<template>
    <div>
      <div>
        <fieldset class="field-header" style="margin-top: 20px;">
            <legend class="f-title">{{title}}</legend>
        </fieldset>
      </div>
    </div>
</template>
<script>
export default {
  data () {
    return {
    }
  },
  props: {
    title: {
      type: String,
      required: true,
      default: ''
    }
  },
  computed: {
  }
}
</script>
<style lang="less" scoped>
.field-header {
  margin-bottom: 10px;
  padding: 0;
  border-width: 1px;
  border-style: solid;
  margin: 10px 0 20px;
  border-width: 1px 0 0;
  border-color: #e6e6e6;
  touch-action: pan-y;
  text-align: left;
  .f-title {
    margin-left: 20px;
    padding: 0 10px;
    font-size: 20px;
    font-weight: 300;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/titleline.vue